import AppHeader from "../../layout/AppHeader";
import Branch from '../../xpost/views/register/branch/Branch.vue';
import BranchAdd from '../../xpost/views/register/branch/BranchAdd.vue';
import BranchImport from '../../xpost/views/register/branch/BranchImport.vue';

const BranchRoutes = [
    {
        path: "/cadastro/filial",
        name: "branch",
        components: {
            header: AppHeader,
            default: Branch,
        }
    },
    {
        path: "/cadastro/filial/adicionar",
        name: "branch.add",
        components: {
            header: AppHeader,
            default: BranchAdd,
        }
    },
    {
        path: "/cadastro/filial/importar",
        name: "branch.import",
        components: {
            header: AppHeader,
            default: BranchImport,
        }
    },
    {
        path: '/cadastro/filial/adicionar/:id',
        name: 'branch.edit',
        components: {
            header: AppHeader,
            default: BranchAdd,
        }
    }
]

export default BranchRoutes;